import { gql } from '@apollo/client';
import { EngagementNotificationSettingFields } from './fragments';

export const GET_ENGAGEMENT_NOTIFICATION_SETTING = gql`
  query GetEngagementNotificationSetting {
    getEngagementNotificationSetting {
      ...EngagementNotificationSettingFields
    }
  }
  ${EngagementNotificationSettingFields}
`;
